export const Logo = ({ className }: { className?: string }) => {
  return (
    <span className={`flex items-center gap-2.5 min-w-0 ${className ?? ''}`}>
      <img src="/mate-avatar.avif" alt="Mat-E" className="h-8 w-8 rounded-lg object-cover shrink-0" />
      <span className="flex flex-col leading-tight min-w-0">
        <span className="text-sm font-semibold tracking-tight truncate">Mat-E Admin</span>
        <span className="text-[10px] uppercase tracking-[0.12em] opacity-55 truncate font-medium">
          ASM International
        </span>
      </span>
    </span>
  )
}
